export const TITLE = 'Question Name';
export const PLACEHOLDER = 'Is this a question?';
